import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import formImage from '../images/PariMoskva_listovka-A4_copy.jpg';
import '../style/OrderForm.css';

const OrderForm = () => {
  const [form, setForm] = useState({
    name: '', phone: '', email: '',
    message: '', day: '', time: '', agreement: true
  });
  const [isSent, setIsSent] = useState(false);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const sendMail = async (e) => {
    e.preventDefault();

    try {
      // параллельно
      await Promise.all([
        emailjs.send('service_3tlcupa', 'template_x7n0nv8', form, 'tMkoEzwlZcuXtAi6u'),
        // sendOrderToTelegram(form),
      ]);

      setIsSent(true);
    } catch (err) {
      alert(err?.message || err?.text || String(err));
    }
  };

  function buildTelegramText(form) {
    const lines = [
      "🛒 <b>Новый заказ</b>",
      "",
      `👤 Имя: <b>${escapeHtml(form.name)}</b>`,
      `📞 Телефон: <b>${escapeHtml(form.phone)}</b>`,
      `📧 Email: ${form.email ? `<b>${escapeHtml(form.email)}</b>` : "-"}`,
      `📅 Дата доставки: ${form.day ? `<b>${escapeHtml(form.day)}</b>` : "-"}`,
      `⏰ Время доставки: ${form.time ? `<b>${escapeHtml(form.time)}</b>` : "-"}`,
      "",
      `📝 Детали:`,
      `${escapeHtml(form.message)}`,
      "",
      `✅ Согласие: ${form.agreement ? "да" : "нет"}`,
    ];
    return lines.join("\n");
  }

  // минимальный escape для HTML parse_mode
  function escapeHtml(str = "") {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;");
  }

  async function sendOrderToTelegram(form) {
    const orderKey = process.env.REACT_APP_ORDER_KEY;
    if (!orderKey) throw new Error("Order key is not configured");

    const resp = await fetch("/api/telegram-order", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-ORDER-KEY": orderKey,
      },
      body: JSON.stringify({ text: buildTelegramText(form) }),
    });

    if (!resp.ok) throw new Error("Telegram failed");
  }


  return (
    <section className="order-section">
      <div className="order-left">
        <img src={formImage} alt="PariMoskva" className="order-image" />
      </div>
      <div className="order-right">
        <h1>Как сделать заказ?</h1>
        <h2>Заполняйте форму и мы свяжемся с вами</h2>
        <form className="form__body" onSubmit={sendMail}>

          {/* Первая строка */}
          <div className="form__item">
            <label className="form__label" htmlFor="name">Ваше имя*</label>
            <input className="form__input" id="name" name="name" value={form.name} onChange={handleChange} required />
          </div>
          <div className="form__item">
            <label className="form__label" htmlFor="phone">Телефон*</label>
            <input className="form__input" id="phone" name="phone" value={form.phone} onChange={handleChange} required />
          </div>
          <div className="form__item">
            <label className="form__label" htmlFor="email">Email</label>
            <input className="form__input" id="email" name="email" value={form.email} onChange={handleChange} />
          </div>

          {/* Вторая строка */}
          <div className="form__item">
            <label className="form__label" htmlFor="day">Дата доставки</label>
            <input className="form__input" id="day" name="day" value={form.day} onChange={handleChange} />
          </div>
          <div className="form__item">
            <label className="form__label" htmlFor="time">Время доставки</label>
            <input className="form__input" id="time" name="time" value={form.time} onChange={handleChange} />
          </div>

          {/* Третья строка */}
          <label className="form__label" htmlFor="message">Детали заказа*</label>
          <textarea id="message" name="message" className="form__input" value={form.message} onChange={handleChange} required />

          {/* Чекбокс */}
          <div className="form__item checkbox">
            <input type="checkbox" id="agreement" name="agreement" checked={form.agreement} onChange={handleChange} />
            <label htmlFor="agreement">Я даю свое согласие...</label>
          </div>

          {/* Кнопка */}
          <div className='order_button'>
            <button type="submit" className="form__button">Отправить заказ</button>
          </div>
        </form>
      </div>
      {isSent && (
        <div
          className="order-success-overlay"
          role="dialog"
          aria-live="polite"
          onClick={() => setIsSent(false)}
        >
          <div className="order-success-banner" onClick={e => e.stopPropagation()}>
            <p>Заказ отправлен</p>
            <p>В скором времени мы с Вами свяжемся</p>
            <button
              type="button"
              className="order-success-close"
              onClick={() => setIsSent(false)}
            >
              Закрыть
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default OrderForm;
